import { ModelStore } from "@clairejs/react";

import { Country } from "../dto/models/country";
import { Currency } from "../dto/models/currency";
import { GeoRegion } from "../dto/models/geo-region";
import { Payment } from "../dto/models/payment";
import { PaymentAccount } from "../dto/models/payment-account";
import { Search } from "../dto/models/search";
import { Service } from "../dto/models/service";
import { ServiceProfile } from "../dto/models/service-profile";
import { SystemAnnounce } from "../dto/models/system-announce";
import { User } from "../dto/models/user";
import { RevenueCashout } from "../dto/models/revenue-cashout";

import { UserInfo } from "../dto/http/user";
import { GetReferalRevenueBalanceResponse, ReferredUser } from "../dto/http/referal";

export type ExplicitColorMode = "dark" | "light";
export type ColorMode = ExplicitColorMode | "auto";

export class DataStore {
    ui?: {
        color?: {
            mode?: ColorMode;
            explicitMode?: ExplicitColorMode;
        };
        sidebar?: {
            unfoldable?: boolean;
            visible?: boolean;
        };
    };
    me?: {
        hasToken?: boolean;
        info?: UserInfo;
    };
    referal?: {
        cashout?: ModelStore<RevenueCashout>;
        users?: ModelStore<ReferredUser>;
        revenue?: {
            balance?: GetReferalRevenueBalanceResponse;
        };
    };
    users?: ModelStore<User>;
    payments?: ModelStore<Payment>;
    search?: ModelStore<Search>;
    data?: {
        geoRegions?: ModelStore<GeoRegion>;
        countries?: ModelStore<Country>;
        services?: ModelStore<Service>;
        accounts?: ModelStore<PaymentAccount>;
        currencies?: ModelStore<Currency>;
    };
    services?: {
        profiles?: ModelStore<ServiceProfile>;
    };
    system?: {
        announces?: ModelStore<SystemAnnounce>;
    };
}
